import { gsap, ScrollTrigger } from "gsap/all";

export function fadeKeyNumbers() {
  gsap.registerPlugin(ScrollTrigger);
  const animationDuration = 0.8;
  const fadeDistance = 8;
  const staggerDelay = 0.08;
  const startPosition = "top 80%";
  const ease = "power2.inOut";

  const wrappers = document.querySelectorAll(".key-numbers-block");
  
  wrappers.forEach((wrapper) => {
    const elements = wrapper.querySelectorAll(".key-number-block");

    elements.forEach((element, index) => {
      const line = element.querySelector('.key-number-block--line');
      const title = element.querySelector('.key-number-block--title');
      const text = element.querySelector('.key-number-block--text');
      const delay = index * staggerDelay;

      gsap.from(line, {
        scaleX: 0,
        duration: animationDuration,
        delay: delay,
        ease: ease,
        scrollTrigger: {
          trigger: wrapper,
          start: startPosition,
          //markers: true,
        }
      });

      gsap.from(title, {
        y: fadeDistance,
        opacity: 0,
        duration: animationDuration,
        delay: delay,
        ease: ease,
        scrollTrigger: {
          trigger: wrapper,
          start: startPosition,
          //markers: true,
        }
      });

      gsap.from(text, {
        y: fadeDistance * 2,
        opacity: 0,
        duration: animationDuration,
        delay: delay,
        ease: ease,
        scrollTrigger: {
          trigger: wrapper,
          start: startPosition,
          //markers: true,
        }
      });
    });
  });
}